import { useIsPlanType } from '../use-is-plan-type';
import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useLibraryTrialAccess = (): boolean => {
  const { isSocialOnly } = useIsPlanType();
  const { vodPlanId, webPlanId } = useCustomer();
  const isMultiSiteOnly = !vodPlanId && !webPlanId;
  const isMultiOrSocialOnly = isSocialOnly || isMultiSiteOnly;

  return !isMultiOrSocialOnly && !vodPlanId;
};

export default useLibraryTrialAccess;
